import React from "react"
import { Heading } from "@chakra-ui/react"

export default function PackageHeading({ name, price }) {
  return (
    <>
      <Heading w="full" fontSize={{ base: "lg", md: "xl" }} textAlign="center">
        {name}
      </Heading>
      <Heading
        textAlign="center"
        fontWeight="bold"
        size="6xl"
        w="full"
        mt={4}
        mb={6}
      >
        £{price}
      </Heading>
    </>
  )
}
